import { render, staticRenderFns } from "./ModelDataSetPanel.vue?vue&type=template&id=2cf737d8&scoped=true"
import script from "./ModelDataSetPanel.vue?vue&type=script&lang=js"
export * from "./ModelDataSetPanel.vue?vue&type=script&lang=js"
import style0 from "./ModelDataSetPanel.vue?vue&type=style&index=0&id=2cf737d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf737d8",
  null
  
)

export default component.exports